module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/Folder-8e0b4f998777b50ec67b0c5c281cdda6cabd367be7ce27b2bae90baba0888cb5.svg";